import React from 'react';
import { formatDateForCreatedDate } from '../../utils/helper';

export default function OfferPdf({ offer, lead, logo }) {
    const { lead_name, phone, email, date_of_birth,enquiry_no } = lead;
    const {
        offer_name,
        offer_date,
        offer_amount,
        number_of_units,
        passenger_capacity,
        total_stops,
        offer_side,
        number_of_openings,
        floor_counts,
        motor,
        lift_speed,
        door_opening,
        door_metal,
        all_doors_same,
        floor_name,
        cabin_metal,
        door_panels,
        door_width,
        door_height,
        door_vision,
        shaft_width,
        shaft_debth,
        shaft_construction,
        machine_room,
        dlp_period,
        brand_offered,
    } = offer;

    const data = {
        offer_amount,
        number_of_units,
        passenger_capacity,
        total_stops,
        offer_side,
        number_of_openings,
        floor_counts,
        motor,
        lift_speed,
        door_opening,
        door_metal,
        all_doors_same,
        floor_name,
        cabin_metal,
        door_panels,
        door_width,
        door_height,
        door_vision,
        shaft_width,
        shaft_debth,
        shaft_construction,
        machine_room,
        dlp_period,
        brand_offered,
    };
    return (
        <div className="d-flex justify-content-center border bg-danger" style={{ fontSize: '10px' }}>
            <table style={{ width: '100%' }}>
                <tbody>
                    <tr>
                        <td colSpan={4} style={{ textAlign: 'center' }}>
                            <img src={logo} alt='' height={'120px'} width={'350px'} />
                            
                        </td>
                        {/* <th style={{textAlign:'center',justifyContent:'center'}}>
                            Fuzi Elevators 
                        </th> */}
                        
                    </tr>
                    <tr>
                        <th colSpan={1}>
                            Enquiry No
                        </th>
                        <td colSpan={1}>
                            {enquiry_no}
                        </td>
                        <th colSpan={1}>
                            Offer Name
                        </th>
                        <td colSpan={1}>
                            {offer_name}
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={1}>
                            Offer Date
                        </th>
                        <td colSpan={1}>
                            {formatDateForCreatedDate(offer_date)}
                        </td>
                        <th>
                            Lead Name
                        </th>
                        <td>
                            {lead_name}
                        </td>
                    </tr>
                    <tr>
                        
                        <th>
                            Phone
                        </th>
                        <td>
                            {phone}
                        </td>

                        <th>
                            Email
                        </th>
                        <td>
                            {email}
                        </td>
                    </tr>
                    <tr>
                        
                        <th colSpan={2}>
                            DOB
                        </th>
                        <td colSpan={2}>
                            {formatDateForCreatedDate(date_of_birth)}
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={4} style={{ textAlign: 'center' }}>
                            Offer Information
                        </th>
                    </tr>
                    {Object.entries(data).map((item, index) => (
                        <tr scope="row" key={index}>
                            <th scope="col" colSpan={2}>{item[0]?.replaceAll("_", " ").split(" ").map((word) => word[0].toUpperCase() + word.slice(1)).join(" ")}</th>
                            <td scope="col" colSpan={2}>{item[1]}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}
